import { defineStore } from 'pinia'

export const useSessionStore = defineStore('session', {
  state: () => ({
    data: JSON.parse(sessionStorage.getItem('session') || '{}')
  }),
  actions: {
    get(key) {
      return this.data[key]
    },
    set(key, val) {
      this.data[key] = val
      sessionStorage.setItem('session', JSON.stringify(this.data))
    },
    start() {
      // no-op for compatibility with vue-session API
    },
    destroy() {
      this.data = {}
      sessionStorage.removeItem('session')
    },
    exists(key) {
      return key in this.data
    }
  }
})
